/// <amd-module name="Analytics/Boards/VelocityQueries/VelocityQueryBase" />
import { AnalyticsCacheableQueryBase } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { BatchRequestMode, ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";

// Analogous to Tfs/Service/WebAccess/Widgets/Scripts/Velocity/Queries/VelocityQueryBase.ts

/**
 * Add days to a date. This is DST safe since it doesn't use getTime() for the adjustment.
 * @param date The date to add days to
 * @param days Number of days to add
 */
export function addDays(date: Date, days: number): Date {
    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days,
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );
}

export abstract class VelocityQueryBase<T> extends AnalyticsCacheableQueryBase<T> {
    constructor(command: string, queryOptions: ODataQueryOptions) {
        const extendedQueryOptions: ODataQueryOptions = {
            ...queryOptions,
            batchRequestMode: BatchRequestMode.Enabled
        };

        super(command, extendedQueryOptions);
    }
}
